// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { NUTRITION_SOURCE_GROUPS, NUTRITION_SOURCE_URLS } from "@bitebalance/i18n"
import { useI18n } from "@/i18n"

/**
 * Sources & method (App Review rejection of the iOS build 1.0.0 (9), Guideline 1.4.1, 2026-10-24): the published
 * sources behind the calorie target, the macro split, the safety minimums and the breastfeeding correction. Web
 * parity of the mobile `/sources` screen; the Goals page links here from the target and macros cards (`#sources`).
 * Copy and URLs are shared through @bitebalance/i18n (nutritionSources.ts).
 */
export function NutritionSources() {
  const { t } = useI18n()
  return (
    <section id="sources" className="flex flex-col gap-3 rounded-bb-md border border-line bg-paper p-5" data-testid="goals-sources">
      <h2 className="text-lg font-semibold text-ink">{t("moreProfile.goals.sources.title")}</h2>
      <p className="text-sm text-ink-2">{t("moreProfile.goals.sources.intro")}</p>
      {NUTRITION_SOURCE_GROUPS.map(group => (
        <div key={group.id} className="flex flex-col gap-1">
          <h3 className="text-base font-semibold text-ink">{t(`moreProfile.goals.sources.groups.${group.id}.title`)}</h3>
          <p className="text-sm text-ink-2">{t(`moreProfile.goals.sources.groups.${group.id}.body`)}</p>
          <ul className="flex list-disc flex-col gap-1 pl-5 text-sm">
            {group.sources.map(id => (
              <li key={id}>
                <a href={NUTRITION_SOURCE_URLS[id]} target="_blank" rel="noreferrer" className="font-medium text-ink underline">
                  {t(`moreProfile.goals.sources.items.${id}.title`)}
                </a>
                <span className="text-ink-2"> — {t(`moreProfile.goals.sources.items.${id}.detail`)}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </section>
  )
}
